<template>
    <section>
		
        <!-- 查询栏 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;"  @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.shopname" @keyup.enter.native="getShop" placeholder="门店名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getShop"  icon="el-icon-search">查询门店信息</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增门店</el-button>
				</el-form-item>
			</el-form>
		</el-col>
        	<!--列表-->
		<el-table :data="shoplist" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column prop="Id" width="120" label="门店ID" >
			</el-table-column> -->
			<el-table-column prop="Name" label="门店名称 " width="150" sortable>
			</el-table-column>
			<el-table-column prop="Count" label="剩余短信" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Balance" label="充值金额" width="120" sortable>
			</el-table-column>
			<el-table-column prop="UnitPrice" label="短信单价" width="120" sortable>
			</el-table-column>
			<el-table-column prop="UsageAmount" label="已使用量" width="120" sortable>
			</el-table-column>										
	     	<el-table-column prop="SMSSign" label="短信签名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="LinkMan" label="联系人" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Mobile" label="手机号码" width="180" sortable>
			</el-table-column>			
			<el-table-column prop="Tel" label="电话号码" width="120" sortable>
			</el-table-column>
			<el-table-column prop="CreationTime" label="创建时间" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="Address" label="地址" width="250" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<!-- <el-table-column  label="闸柜模式" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				     <el-dropdown trigger="click">
                      <el-button type="danger"  v-if="scope.row.MachineState==0||scope.row.MachineState==null" size="small" >不使用设备</el-button>
                      <el-button type="success"  v-else-if="scope.row.MachineState==1" size="small" >全智能</el-button>
					   <el-button type="warning"   v-else-if="scope.row.MachineState==2" size="small" >半智能</el-button>
                     <el-dropdown-menu slot="dropdown" >
                         <el-dropdown-item class="clearfix" @click.native="ChangeMachineState(scope.row,0)" >
                            不使用设备
                          </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeMachineState(scope.row,2)">
                            半智能
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" @click.native="ChangeMachineState(scope.row,1)">
                            全智能
                         </el-dropdown-item>	
					 					 
                     </el-dropdown-menu>
                     </el-dropdown>				
					 	 </template>
			</el-table-column>
			<el-table-column  label="进出模式" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				     <el-dropdown trigger="click">
                      <el-button type="success"  v-if="scope.row.Pattern==0||scope.row.Pattern==null" size="small" >一进一出</el-button>
					   <el-button type="warning"   v-else-if="scope.row.Pattern==1" size="small" >多进多出</el-button>
                     <el-dropdown-menu slot="dropdown" >
                           <el-dropdown-item class="clearfix"  v-if="scope.row.Pattern==1" @click.native="ChangePatternState(scope.row)">
                            一进一出
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" v-if="scope.row.Pattern==0||scope.row.Pattern==null" @click.native="ChangePatternState(scope.row)">
                            多进多出
                         </el-dropdown-item>	
					 					 
                     </el-dropdown-menu>
                     </el-dropdown>				
					 	 </template>
			</el-table-column>						
			<el-table-column  label="微信上线开关" width="150" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="shoplist[scope.$index].Id"   v-model="shoplist[scope.$index].State==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="Change(scope.row,shoplist[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>	
			<el-table-column prop="MsgPower" label="通知方式" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
				     <el-dropdown trigger="click">

                      <el-button type="info" v-if="scope.row.MsgPower==0||scope.row.MsgPower==null" size="small" >短信通知</el-button>
                      <el-button type="success"  v-else-if="scope.row.MsgPower==2" size="small" >微信通知</el-button>
					   <el-button type="warning"   v-else-if="scope.row.MsgPower==3" size="small" >混合通知</el-button>
                      <el-button type="danger"   v-else-if="scope.row.MsgPower==1" size="small" >停用通知</el-button>

                     <el-dropdown-menu slot="dropdown" >
                         <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,0)" >
                            短信通知
                          </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,2)">
                            微信通知
                         </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,3)">
                            混合通知
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,1)">
                            停用通知
                         </el-dropdown-item>	
					 					 
                     </el-dropdown-menu>
                     </el-dropdown>	
                  </template>
			</el-table-column>			 -->
			<!-- <el-table-column  label="短信开关" width="150" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="shoplist[scope.$index].Id"   v-model="shoplist[scope.$index].MsgPower==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="Change2(scope.row,shoplist[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>					 -->
			<el-table-column label="操作" width="480" fixed="right">
				<template  slot-scope="scope">					
					<el-button type="success" size="small" @click="editorShow(scope.row)">门店简介</el-button>
					<el-button type="success" size="small" @click="editorPayment(scope.row)">门店支付信息</el-button>
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="warning" size="small" @click="handleRecharge(scope.$index, scope.row)">充值</el-button>
					<el-button type="primary" size="small" @click="rechargeLog(scope.$index, scope.row)">查看充值记录</el-button>
				</template>
			</el-table-column>
		</el-table>
        <!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!-- <el-col :span="24"  class="footer">底部</el-col> -->
       	<!--编辑界面-->
		<el-dialog title="编辑门店" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="门店名称" prop="Name">
					<el-input v-model="editForm.Name" auto-complete="off"></el-input>
				</el-form-item>
			 	<el-form-item label="短信签名" prop='SMSSign'>
					<el-input v-model="editForm.SMSSign" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="短信单价" prop='UnitPrice'>
					<el-input v-model.number="editForm.UnitPrice"  auto-complete="off"></el-input>			
				</el-form-item>	
			    <el-form-item label="联系人" >
					<el-input v-model="editForm.LinkMan" auto-complete="off"></el-input>
				</el-form-item>
			
				<el-form-item label="手机号码">
					<el-input  v-model="editForm.Mobile" auto-complete="off"></el-input>
				</el-form-item>
		       		<el-form-item label="电话号码">
					<el-input  v-model="editForm.Tel" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="地址">
					<el-input  v-model="editForm.Address" auto-complete="off"></el-input>
				</el-form-item>
				
			    <el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
        
        <!-- 充值界面 -->
		<el-dialog title="短信充值" v-model="RechargeFormVisible" :close-on-click-modal="false">
			<el-form :model="RechargeForm" label-width="100px" :rules="RechargeFormRules" ref="RechargeForm">
				<el-form-item label="充值数量" prop="Count">
					<el-input v-model.number="RechargeForm.Count" auto-complete="off" @change="Count()"></el-input>
				</el-form-item>
				<el-form-item label="充值单价" prop="UnitPrice">
					<el-input v-model.number="RechargeForm.UnitPrice" auto-complete="off" @change="UnitPrice()"></el-input>
				</el-form-item>
				<el-form-item label="充值金额" prop="Money" >
					<el-input  v-model.number="RechargeForm.Money" auto-complete="off" ></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="RechargeFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="RechargeSubmit" :loading="RechargeLoading">提交</el-button>
			</div>
		</el-dialog>


        	<!--新增界面-->
		<el-dialog title="新增门店" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
				<el-form-item label="门店名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
			 	<el-form-item label="短信签名"  prop="SMSSign">
					<el-input v-model="addForm.SMSSign" auto-complete="off"></el-input>
				</el-form-item>
			    <el-form-item label="联系人" >
					<el-input v-model="addForm.LinkMan" auto-complete="off"></el-input>
				</el-form-item>
			
				<el-form-item label="手机号码">
					<el-input  v-model="addForm.Mobile" auto-complete="off"></el-input>
				</el-form-item>
		       		<el-form-item label="电话号码">
					<el-input  v-model="addForm.Tel" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="地址">
					<el-input  v-model="addForm.Address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="会员版本">
					<el-radio-group v-model="addForm.SkinVersion">
						<el-radio class="radio" :label="0">标准会员</el-radio>
						<el-radio class="radio" :label="1">收费会员</el-radio>
					</el-radio-group>
				</el-form-item>
			    <el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!-- 充值记录 -->
        <el-dialog :title="TitleName" v-model="dialogTableVisible" @close='closeing' >
           <el-table :data="ShopRechargeData" highlight-current-row v-loading="logLoading">	
			<el-table-column prop="Count" label="充值数量" width="120" sortable>
			</el-table-column>
			<el-table-column prop="UnitPrice" label="充值单价" width="120" sortable>
			</el-table-column>				
			<el-table-column prop="Money" label="充值金额" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="CreationTime" label="充值时间" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
		    <el-table-column prop="State" label="记录状态"  width="120" sortable fixed="right">  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.State==0">已撤销</el-tag>
                  <el-tag type="success" size="medium" v-else>正常</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column label="操作" width="100" fixed="right">
				<template  slot-scope="scope">
					<!-- <el-button type="danger" size="small" v-if="scope.row.State!=0" @click="handleEdit(scope.$index, scope.row)">撤销充值</el-button>
					<el-button type="danger" size="small" v-else disabled="true" @click="handleEdit(scope.$index, scope.row)">撤销充值</el-button> -->
					<el-button type="danger" size="small" :disabled="scope.row.State==0" @click="cancel(scope.$index, scope.row)">撤销充值</el-button>

					<!-- Recharge -->
				</template>
			</el-table-column>
           </el-table>
		   	<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-tag>共有{{logCount}}条充值记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="CurrentChange" :page-size="10" :total="logCount" style="float:right;">
			</el-pagination>
	     	</el-col>
        </el-dialog>


    </section>
</template>
<script>
	import {ChangePattern,MachineStateSet,MsgPowerSet,CancelOrder,rechargeLogPaging,rechargeshop,getShopList, removeshop, editshopt, addshop,ShopOnlineSet } from '../../api/api';
export default {
    data(){
        return{
			   editorModel:false,
            filters: {
					Name: ''
				},
				  //充值记录相关
				  TitleName:'',
				  dialogTableVisible:false,
				  ShopRechargeData:[],
				  logCount:0,
				  ShopId:0,
				  logLoading:false,
				  logPage:0,
				  //


				// 短信充值相关
				RechargeFormVisible:false,
				RechargeForm:{
					Id: 0,
					Count:1,
					Money:0,
					UnitPrice:0.1
				},
                 RechargeFormRules:{
					Count: [
						{ required: true, message: '请输入短信充值数量'},
                        { type: 'number', message: '必须为数字值'}
					],
					Money: [
						{ required: true, message: '请输入短信充值金额'},
                        { type: 'number', message: '必须为数字值'}
					],
					UnitPrice: [
						{ required: true, message: '请输入短信充值单价'},
                        { type: 'number', message: '必须为数字值'}
					],
	
				 },
				 RechargeLoading:false,
				//  --
                shoplist: [],
				total: 0,
				page: 0,
                listLoading: false,
                sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					Name: [
						{ required: true, message: '请输入门店名称', trigger: 'blur' }
					],
					SMSSign:[
						{ required: true, message: '请输入短信签名', trigger: 'blur' }	
					],
					UnitPrice:[{ required: true, message: '请输入短信单价'},
                        { type: 'number', message: '必须为数字值'}]				
				},
				//编辑界面数据
				editForm: {
					Id: 0,
					Name: '',
				    SMSSign:'',
                    LinkMan:'',
					Mobile:'',
                    Tel:'',
					Address:'',
					Remark:'',
					UnitPrice:0					
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Name: [
						{ required: true, message: '请输入门店名称', trigger: 'blur' }
					],
					SMSSign:[
						{ required: true, message: '请输入短信签名', trigger: 'blur' }	
					]					
				},
				//新增界面数据
				addForm: {
				    Name: '',
				    SMSSign:'SMSSign',
                    LinkMan:'',
					Mobile:'',
                    Tel:'',
					Address:'',
					SkinVersion:'',
					Remark:''					
				}
        }
    },
    methods:{
		ChangePatternState(row)
		  {
			  	let para={
						id:row.Id
				}						  
              ChangePattern(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.Pattern=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});			  

		  },
		ChangeMachineState(row,code)
		{
			  	let para={
						id:row.Id,	
						stateCode:code			
				}						  
              MachineStateSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.MachineState=code;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});			  
		},
		Change(row,index)
			{
				let para={
						id:index,				
				}
              ShopOnlineSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.State=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},
			ChangeState(row,index)
			{
				let para={
						id:row.Id,
						stateCode:index				
				}
              MsgPowerSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.MsgPower=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});				

			},
	   editorShow(row)
	   {
		   var _this = this;
		 this.$router.push({
          name: '门店简介',
          params: {
            id: row.Id
          }
        })
		//    _this.$router.push('/ShopIntroduction/${id}');
		//    this.editorModel=true;
		//    var ue = UE.getEditor('editor');
	   },
	   editorPayment(row)
	   {
		   var _this = this;
		 this.$router.push({
          name: '支付信息',
          params: {
            id: row.Id
          }
        })

	   },
         Count(){
			 this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;
		 },
		 UnitPrice()
		 {
			 this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;

		 },
		closeing()
		{
            this. getShop();
		},
          	handleCurrentChange(val) {
                this.page = val;
                //
				this.getShop();
			},
			CurrentChange(val)
			{
                this.logPage = val;
                //
				this.rechargeLogData();
			},
            	//获取门店列表
			 getShop() {
				let Params = {
					PageIndex: this.page-1,
					
					PageSize:10,
					Name:this.filters.shopname
				};
				this.listLoading = true;
				getShopList(Params).then((res) => {
					this.total = res.data.TotleCount;
					this.shoplist = res.data.Data;
					this.listLoading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
            },
            	//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
				// console.log(this.editForm);
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
				     Name: '',
				      SMSSign:'SMSSign',
                    LinkMan:'',
					Mobile:'',
                    Tel:'',
					Address:'',
					Remark:''									
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							editshopt(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								// this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this. getShop();
							});
						});
					}
				});
			},
		  cancel: function (index,row) {								
						this.$confirm('确认撤销吗？', '提示', {}).then(() => {
							// this.editLoading = true;
							//NProgress.start();						
							let para = Object.assign({}, row);
							CancelOrder(para).then((res) => {
								// this.editLoading = false;
								let { Success,Msg } = res.data;
								if(Success)
								{			
									row.State=res.data.Data.State;					
								this.$message({
									message: Msg,
									type: 'success'
								});
								}
								else
								{
									this.$message({message:Msg,type:'error'});
								}
								// this.$refs['editForm'].resetFields();								
								// this. getShop();
							});
						});									
			},
			handleRecharge:function(index,row){
				this.RechargeForm={};
                this.RechargeFormVisible=true;
				this.RechargeForm=Object.assign({},row);
				this.RechargeForm.Count=1;
				this.RechargeForm.Money=0;
				this.RechargeForm.UnitPrice=row.UnitPrice;
				this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;
			},
            RechargeSubmit: function () {
				this.$refs.RechargeForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.RechargeLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.RechargeForm);
							rechargeshop(para).then((res) => {
								this.RechargeLoading = false;
								//NProgress.done();
								//NProgress.done();
								let { Success,Msg } = res.data;
					            if(Success)
						         {
                                  this.$message({
							     message: Msg,
						        	type: 'success'
						          });
						          this.getShop();
					            	}
					        	else
					         	{
                                  this.$message({
						        	message: Msg,
						        	type: 'error'
					            	});
					           	}								
								// this.$refs['editForm'].resetFields();
								this.RechargeFormVisible = false;
								this. getShop();
							});
						});
					}
				});
			},
			rechargeLog:function(index,row){
				this.dialogTableVisible=true;
				this.TitleName=row.Name;
				this.ShopId=row.Id;
				this.ShopRechargeData=[];
				this.rechargeLogData();
			},
			rechargeLogData(){
				let Params = {
					PageIndex: this.logPage-1,					
					PageSize:10,
					ShopId:this.ShopId
				};			
				this.logLoading	=true;  
				  rechargeLogPaging(Params).then((res) => {
					//  console.log(res);
					//前端mock测试
					this.logCount = res.data.TotleCount;
					this.ShopRechargeData = res.data.Data;
					this.logLoading=false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.addForm);
							addshop(para).then((res) => {
								let {Success,Msg}=res.data;
								if(Success)
								{
								this.$message({
									message: Msg,
									type: 'success'
								});
								 this.addLoading = false;
								 this.addFormVisible = false;
								this. getShop();								 
								}
								else
								{
								    this.$message({
									message: Msg,
									type: 'error'
							        	});
								 this.addLoading = false;

								}

								//NProgress.done();

								this.$refs['addForm'].resetFields();


							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
            },
			selsChange: function (sels) {
				this.sels = sels;
			},
    },
    mounted() {
			this. getShop();
			
		}
}
</script>




// WEBPACK FOOTER //
// ShopList.vue?5e87ba30